export const stateName = 'packageSizes';